<mat-progress-bar mode="determinate" [value]="uploadQueue.totalProgress() | async" color="accent"></mat-progress-bar>